$(document).ready(function(){
 $('.catalog__grid-block .GridIcon__row').on('click',function(){
   $(this).addClass('active').siblings().removeClass('active');
   $('#product-grid').attr('class', '');
   var div_class = $(this).attr('data-class');
   $('#product-grid').addClass('grid product-grid grid--2-col-tablet-down').addClass(div_class);
 });


          
$('.slid').slick({
  centerMode:true,
  centerPadding: '10px',
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><svg style='stroke: #666;' xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'><polyline points='15 18 9 12 15 6'></polyline></svg></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><svg style='stroke: #666;' xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'><polyline points='9 18 15 12 9 6'></polyline></svg></button>",
  responsive: [  
    {
      breakpoint:995,
      settings: {
        arrows: false,
        centerMode: true,       
        slidesToShow: 3
      }
    },
    {
      breakpoint:1028,
      settings: {
        arrows: false,
        centerMode: true,       
        slidesToShow: 2
      }
    },         
    {
      breakpoint:810,
      settings: {
        arrows: false,
        centerMode: true,       
        slidesToShow: 2
      }
    },        
    {
      breakpoint: 480,
      settings: {
        arrows:false,
        centerMode: true,
        slidesToShow: 1
      }
    }
  ]
});
$('#category_slider').slick({
  centerMode:true,
  centerPadding: '10px',
  slidesToShow:4,
  slidesToScroll: 1,
       prevArrow:"<button type='button' class='slick-prev pull-left'><svg style='stroke: #666;' xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'><polyline points='15 18 9 12 15 6'></polyline></svg></button>",
     nextArrow:"<button type='button' class='slick-next pull-right'><svg style='stroke: #666;' xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'><polyline points='9 18 15 12 9 6'></polyline></svg></button>",
        responsive: [  
      {
          breakpoint: 2241,
        settings: "unslick"
      },     
     {
          breakpoint: 2000,
        settings: "unslick"
      },
      {
        breakpoint: 1600,
        settings: "unslick"
      },
      {
        breakpoint: 1024,
        settings: "unslick"
      },
       {
      breakpoint:992,
      settings: {
        arrows: false,
        centerMode: true,       
        slidesToShow: 3
      }
    },
      {
      breakpoint:768,
      settings: {
        arrows: false,
        centerMode: true,       
        slidesToShow: 2
      }
    },         
    {
      breakpoint:600,
      settings: {
        arrows: false,
        centerMode: true,       
        slidesToShow: 1 
      }
    }
  
  ]
});


console.history = [];
var oldConsole = {};
for (var i in console) {
    if (typeof console[i] == 'function') {
        oldConsole[i] = console[i];
        var strr = '(function(){\
            console.history.push({func:\'' + i + '\',args : Array.prototype.slice.call(arguments)});\
            oldConsole[\'' + i + '\'].apply(console, arguments);\
        })';
        console[i] = eval(strr);
    }
}
});


